module.exports = __webpack_public_path__ + "img/Download.650a0cd1.svg";